/* Supps247 12 Oct 2026 (rollback folder 85). Click & collect stock on product pages.
   Reads pickup stock for the selected variant (Shopify store availability, the same data checkout uses) and:
   1. marks stores in the "Pick up from" list that have it in stock,
   2. says whether the chosen store has it, and suggests stores that do,
   3. hides the old "Pickup currently unavailable at <first store>" card once this has loaded.
   Read only. Nothing is written except the store choice that s247-fx.js already keeps in the browser. */
(function () {
  'use strict';
  if (window.__s247pick) return; window.__s247pick = 1;
  function start() {
    try {
      var boxes = [].slice.call(document.querySelectorAll('[data-mlyn-pickup]'));
      if (!boxes.length) return;
      var css = document.createElement('style');
      css.textContent =
        '.s247-stock{margin:8px 0 2px;font-size:13px;line-height:1.45;color:#3b4a55}' +
        '.s247-stock p{margin:0}' +
        '.s247-stock__line{display:flex;gap:8px;align-items:flex-start}' +
        '.s247-stock__line i{flex:0 0 8px;width:8px;height:8px;margin-top:6px;border-radius:50%;background:#9aa6b2}' +
        '.s247-stock__line.is-on i{background:#16a34a;box-shadow:0 0 0 3px rgba(22,163,74,.15)}' +
        '.s247-stock__line.is-off i{background:#ea580c;box-shadow:0 0 0 3px rgba(234,88,12,.14)}' +
        '.s247-stock__line b{color:#0B1F2E}' +
        '.s247-stock__alt{margin-top:6px!important;display:flex;flex-wrap:wrap;gap:6px;align-items:center}' +
        '.s247-stock__alt span{color:#5D7488}' +
        '.s247-stock__alt button{border:1px solid #cfe3f2;background:#f3f9fe;color:#0C6BA8;border-radius:999px;padding:3px 10px;font-size:12px;font-weight:600;cursor:pointer;line-height:1.5}' +
        '.s247-stock__alt button:hover{background:#e3f1fb}' +
        '.s247-pick-live .x-container-pickup-availability{display:none!important}';
      document.head.appendChild(css);

      function key(n) {
        n = String(n || '').toLowerCase().replace(/supps\s*247/g, '').replace(/[^a-z0-9]/g, '');
        if (n === 'southyarra') n = 'chapelstreet';
        return n;
      }
      function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

      var cache = {}, data = null, url = boxes[0].getAttribute('data-s247-url') || location.pathname;
      var j = boxes[0].querySelector('[data-s247-pickup-json]');
      if (j) { data = parse(j); if (data) cache[data.v] = data; }

      var names = {};
      var firstSel = boxes[0].querySelector('[data-mlyn-pickup-select]');
      if (firstSel) [].forEach.call(firstSel.options, function (o) { if (o.value) names[key(o.getAttribute('data-name') || o.textContent)] = { name: o.getAttribute('data-name') || o.textContent, value: o.value }; });

      function render() {
        var m = {};
        if (data && data.s) data.s.forEach(function (x) { m[key(x.n)] = x; });
        var inStock = Object.keys(m).filter(function (k) { return m[k].a && names[k]; }).sort(function (a, b) { return (b === 'reservoir') - (a === 'reservoir'); });
        boxes.forEach(function (box) {
          var sel = box.querySelector('[data-mlyn-pickup-select]'), out = box.querySelector('[data-s247-stock]');
          if (!sel || !out) return;
          [].forEach.call(sel.options, function (o) {
            if (!o.value) return;
            var base = o.getAttribute('data-name') || o.textContent;
            var r = m[key(base)];
            o.textContent = base + (r && r.a ? ' · in stock' : '');
          });
          var o = sel.options[sel.selectedIndex], html = '';
          if (!data) { out.hidden = true; return; }
          if (o && o.value) {
            var nm = o.getAttribute('data-name') || o.textContent, r = m[key(nm)];
            if (!r) {
              html = '<p class="s247-stock__line is-off"><i></i><span>Online pickup isn’t set up at ' + esc(nm) + ' yet. Choose another store, or get it delivered.</span></p>';
            } else if (r.a) {
              html = '<p class="s247-stock__line is-on"><i></i><span><b>In stock at ' + esc(nm) + '.</b> ' + esc(r.t || '') + '. Choose Pickup at checkout.</span></p>';
            } else {
              html = '<p class="s247-stock__line is-off"><i></i><span>Not in stock for pickup at ' + esc(nm) + ' right now.</span></p>';
            }
            if ((!r || !r.a) && inStock.length) {
              html += '<p class="s247-stock__alt"><span>In stock at:</span>' + inStock.slice(0, 5).map(function (k) {
                return '<button type="button" data-s247-pick="' + esc(names[k].value) + '">' + esc(names[k].name.replace(/^Supps247\s*/i, '')) + '</button>';
              }).join('') + '</p>';
            }
          } else if (inStock.length) {
            html = '<p class="s247-stock__line is-on"><i></i><span><b>In stock for pickup at ' + inStock.length + ' store' + (inStock.length > 1 ? 's' : '') + '.</b> Choose your store to check.</span></p>';
          } else {
            html = '<p class="s247-stock__line is-off"><i></i><span>Not in stock for pickup right now. Delivery is still available.</span></p>';
          }
          out.innerHTML = html; out.hidden = !html;
        });
        document.documentElement.classList.toggle('s247-pick-live', !!data);
      }

      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('[data-s247-pick]');
        if (!b) return;
        e.preventDefault();
        var sel = b.closest('[data-mlyn-pickup]').querySelector('[data-mlyn-pickup-select]');
        sel.value = b.getAttribute('data-s247-pick');
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      boxes.forEach(function (box) {
        var sel = box.querySelector('[data-mlyn-pickup-select]');
        if (sel) sel.addEventListener('change', function () { setTimeout(render, 0); });
      });

      function currentId() {
        var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        return f && f.value ? String(f.value) : null;
      }
      var last = data ? String(data.v) : null, busy = false;
      function check() {
        var id = currentId();
        if (!id || id === last || busy) return;
        last = id;
        if (cache[id]) { data = cache[id]; render(); return; }
        busy = true;
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(id) + '&section_id=s247-pickup-data', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-s247-pickup-json]');
            var p = d ? parse(d) : null;
            if (p && String(p.v) === id) { cache[id] = p; data = p; } else { data = null; }
            render();
          })
          .catch(function () { data = null; render(); })
          .then(function () { busy = false; if (currentId() !== last) check(); });
      }
      document.addEventListener('change', function () { setTimeout(check, 50); });
      setInterval(check, 700);
      render();
    } catch (err) { window.console && console.warn('s247-pickup', err); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
